import { Card, CardContent, CardHeader, Grid, Grid2 } from "@mui/material"
import DetailSantri from "../../components/Main/DetailSantri";
import DetailDownload from "../../components/Main/DetailDownload";
import DetailProgress from "../../components/Main/DetailProgress";
import DetailUpload from "../../components/Main/DetailUpload";
import DetailUndangan from "../../components/Main/DetailUndangan";
import DetailKelengkapan from "../../components/Main/DetailKelengkapan";
import DetailPembayaran from "../../components/Main/DetailPembayaran";
import DetailPengumuman from "../../components/Main/DetailPengumuman";
import { useEffect, useState } from "react";
import { Commons } from "../../helper/CommonService";
import { API_HOST } from "../../helper/Constant";
import AuthSection from "../../components/general/AuthSection";

function Main() {
    const [dataSantriLengkap, setDataSantriLengkap] = useState([]);
    const [dataSantri, setDataSantri] = useState({});
    const [dataTujuan, setDataTujuan] = useState({});
    const [dataBerkas, setDataBerkas] = useState({});
    const [dataBayar, setDataBayar] = useState([]);
    const [forceTrigger, setForceTrigger] = useState(1);

    const ForceRefresh = () => {
        setForceTrigger((prev) => prev + 1);
    }

    useEffect(() => {
        let idSantri = Commons.GetAuthDataInStorage("id");
        Promise.all([
            Commons.GetDetailData(API_HOST + "/items/data_santris/" + idSantri+'?fields=*.*', true),
            // Commons.GetDetailData(API_HOST + "/progress/" + idSantri),
            // Commons.GetDetailData(API_HOST + "/items/data_berkas?filter[data_santri]=" + idSantri,true)
        ])
            .then(([
                dataResponseRegister, 
                // dataResponseProgress, 
                // dataResponseBerkas
            ]) => {
                setDataSantriLengkap(dataResponseRegister);
                setDataSantri(dataResponseRegister);
                setDataTujuan(dataResponseRegister["data_tujuan"] ? dataResponseRegister["data_tujuan"][0] : null);
                setDataBayar(dataResponseRegister["pembayarans"]);
//                setDataProgress(dataResponseProgress);
                setDataBerkas(dataResponseRegister["data_berkas"] ? dataResponseRegister["data_berkas"][0] : null);
            })
            .catch((errData) => {
                console.log(errData);
            });
    }, [forceTrigger]);
    return (
        <>
            <AuthSection></AuthSection>
            <Grid container spacing={2}>
                <Grid sx={{ paddingLeft: '10px' }} xs={12} xl={6} lg={6} sm={12} md={6}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={12}>
                            <DetailSantri fileFoto={dataBerkas.foto_santri} dataSantri={dataSantri} dataTujuan={dataTujuan}></DetailSantri>
                        </Grid2>
                        <Grid2 size={12}>
                            <DetailProgress pembayarans={dataBayar} dataSantri={dataSantri} dataBerkas={dataBerkas}></DetailProgress>
                        </Grid2>
                        <Grid2 size={12}>
                            <DetailUndangan data_santri={dataSantri} dataBerkas={dataBerkas}></DetailUndangan>
                        </Grid2>
                        <Grid2 size={12}>
                            <DetailPengumuman data_santri={dataSantri}></DetailPengumuman>
                        </Grid2>
                    </Grid2>
                </Grid>
                <Grid sx={{ paddingLeft: '10px' }} xs={12} xl={6} lg={6} sm={12} md={6}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={12}>
                            <DetailDownload dataSantriLengkap={dataSantriLengkap}></DetailDownload>
                        </Grid2>
                        <Grid2 size={12}>
                            <DetailUpload forceRefresh={ForceRefresh} idSantri={dataSantri.id}></DetailUpload>
                        </Grid2>
                        <Grid2 size={12}>
                            <DetailKelengkapan pembayarans={dataBayar} dataBerkas={dataBerkas} />
                        </Grid2>
                        <Grid2 size={12}>
                            <DetailPembayaran dataSantri={dataSantri} dataJenjangTujuan={dataTujuan.jenjang_tujuan} dataBayar={dataBayar}></DetailPembayaran>
                        </Grid2>
                    </Grid2>
                </Grid>
            </Grid>

        </>
    );
}

export default Main;